import { useCampaignGroupPickerSorting } from '../../hooks/useCampaignGroupPickerSorting';
import { CampaignGroupSorting } from '../CampaignGroupSorting/CampaignGroupSorting';
import styles from '../CampaignSortComponent/CampaignSortComponent.module.scss';

export const CampaignGroupSortComponent = () => {
    const { sortGetter, setSort } = useCampaignGroupPickerSorting();
    return (
        <div className={styles['container']}>
            <CampaignGroupSorting sort={sortGetter()} onSort={setSort} />
        </div>
    );
};
